module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8I3FM"))).then(() => parcelRequire('hEqeo'));